import React from "react";

import logo from "../assets/my-loader.svg";

const LoadingSpinner = () => {

  return (
    <>
      <img src={logo} alt="loading" />
    </>
  );
};

export default LoadingSpinner;
